import React, { useContext } from 'react';
import { DeclaredComponent } from '../../DynamicComponent';
import { GlobalStateContext } from '../../../context/GlobalStateProvider';

export const LandingPage = ({ content }) => {
  const { isTablet, isMobile } = useContext(GlobalStateContext);
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: isTablet || isMobile ? 'column' : 'row',
        paddingBottom: '60px'
      }}
    >
      {content &&
        content.map((component, index) => {
          return <DeclaredComponent declaration={component} key={index} />;
        })}
    </div>
  );
};
